"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = require("../index");
var project_1 = tslib_1.__importDefault(require("../../system/project"));
var state_1 = tslib_1.__importDefault(require("../../system/state"));
// import CityResource from '../../system/city'
var fee_1 = tslib_1.__importDefault(require("../../system/fee"));
var department_1 = tslib_1.__importDefault(require("../../system/department"));
var exports_1 = tslib_1.__importDefault(require("../exports"));
// @todo
// /prs/{pk}/calculate_fees
// /prs/{pk}/validate
// /prs/{pk}/lines
// /prs/{pk}/detaillines
var PayrollResource = /** @class */ (function (_super) {
    tslib_1.__extends(PayrollResource, _super);
    function PayrollResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PayrollResource.related = function () {
        return Object.assign({}, index_1.BaseTransactionResource.related(), {
            project: project_1.default,
            state: state_1.default,
            //work_city: CityResource
            excluded_fees: fee_1.default,
            department: department_1.default,
            export: exports_1.default
        });
    };
    PayrollResource.endpoint = '/prs';
    PayrollResource.MODEL_NAME = 'payroll';
    return PayrollResource;
}(index_1.BaseTransactionResource));
exports.default = PayrollResource;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/pr/index.js
// module id = BUiU
// module chunks = 0